<template>
  <BModal
    :model-value="modal"
    scrollable
    centered
    no-close-on-backdrop
    title="Extra Charge"
    @update:modelValue="updateModal"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between modal-title w-100"
      >
        <h5 class="mb-0 title">Extra Charge</h5>
        <!-- <div class="d-flex gap-2 align-items-center">
          <span class="date">17/02/2025 16:00:00</span>
          <span
            class="bg-success rounded-circle bar-status"
            style="width: 10px; height: 10px"
          ></span>
          <span class="info-status">online: <span>Ruth</span></span>
        </div> -->
      </div>
      <BButton variant="link" class="close" @click="closeModal">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>

    <BForm>
      <BRow v-for="(ext, index) in extraChargeItems" :key="index" class="mb-3">
        <BCol md="5">
          <BFormSelect
            v-model="ext.selectedExtraChargeCategory"
            :options="extraChargeCategories"
            text-field="name"
            value-field="uuid"
            @change="
              () =>
                handleExtraChargeCategory(
                  ext.selectedExtraChargeCategory,
                  index
                )
            "
          >
            <template #first>
              <BFormSelectOption :value="null" disabled
                >Select Category</BFormSelectOption
              >
            </template>
          </BFormSelect>
        </BCol>

        <BCol md="3">
          <BFormSelect
            v-model="ext.selectedExtraChargeUuid"
            :options="ext.extracharges"
            text-field="name"
            value-field="uuid"
            @change="
              () => handleExtraCharge(ext.selectedExtraChargeUuid, index)
            "
          >
            <template #first>
              <BFormSelectOption :value="null" disabled
                >Select Item</BFormSelectOption
              >
            </template>
          </BFormSelect>
        </BCol>

        <BCol md="4">
          <BInputGroup>
            <BButton
              variant="light"
              class="border"
              @click="decreaseQuantity(index)"
            >
              <i class="fas fa-minus"></i>
            </BButton>
            <BFormInput
              type="number"
              v-model="ext.quantity"
              min="0"
              class="text-center"
            />
            <BButton
              variant="light"
              class="border"
              @click="increaseQuantity(index)"
            >
              <i class="fas fa-plus"></i>
            </BButton>
          </BInputGroup>
        </BCol>
      </BRow>

      <div class="d-flex gap-2 my-2">
        <BButton variant="danger" @click="deleteItemExtracharge"
          ><i class="fas fa-minus"></i
        ></BButton>
        <BButton variant="success" @click="addItemExtraCharge"
          ><i class="fas fa-plus"></i
        ></BButton>
      </div>

      <div class="d-flex justify-content-end align-items-center">
        <p class="m-0">
          Total Price : <strong>{{ formatIDR(totalExtraChargePrice) }}</strong>
        </p>
      </div>
    </BForm>

    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton
          variant="primary"
          @click="handleAction"
          class="mr-2"
          :disabled="isLoading"
        >
          {{ isLoading ? "Loading..." : "Save" }}
        </BButton>
        <BButton variant="danger" @click="closeModal">Cancel</BButton>
      </div>
    </template>
  </BModal>

  <ToastResponse
    v-model="modalResponse.toast"
    :text="modalResponse.text"
    :success="modalResponse.success"
  />
</template>

<script>
import { ref, computed, inject, onMounted, watch } from "vue";
import { formatIDR } from "@/utils/currency";
import ToastResponse from "@/components/ToastResponse.vue";
import {
  BModal,
  BFormInput,
  BFormSelect,
  BFormSelectOption,
  BForm,
  BRow,
  BCol,
  BInputGroup,
  BButton,
} from "bootstrap-vue-next";

export default {
  components: {
    ToastResponse,
    BModal,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BForm,
    BRow,
    BCol,
    BInputGroup,
    BButton,
  },
  props: {
    modal: Boolean,
    uuid: String,
    from: String,
  },
  emits: ["update:modal", "addedExtraCharge"],
  setup(props, { emit }) {
    const repositories = inject("repositories");
    const extraChargeCategoryRepository = repositories?.extraChargeCategory;
    const extraChargeRepository = repositories?.extraCharges;
    const reservationRepository = repositories?.reservations;

    const isLateAdded = ref(false);

    const isLoading = ref(false);
    const extraChargeItems = ref([
      {
        selectedExtraChargeUuid: null,
        selectedExtraChargeCategory: null,
        extracharges: [],
        quantity: 0,
        price: 0,
      },
    ]);
    const extraChargeCategories = ref([]);

    const modalResponse = ref({ toast: false, text: "", success: false });

    const getListExtraChargeCategory = () => {
      extraChargeCategoryRepository
        .getAll()
        .then((res) => (extraChargeCategories.value = res.data.data))
        .catch(console.error);
    };

    const getListExtraCharge = (categoryUuid, index) => {
      extraChargeRepository
        .getAll({ extra_charge_category_uuid: categoryUuid })
        .then(
          (res) => (extraChargeItems.value[index].extracharges = res.data.data)
        )
        .catch(console.error);
    };

    const addItemExtraCharge = () => {
      extraChargeItems.value.push({
        selectedExtraChargeUuid: null,
        selectedExtraChargeCategory: null,
        extracharges: [],
        quantity: 0,
        price: 0,
      });
    };

    const deleteItemExtracharge = () => {
      if (extraChargeItems.value.length > 1) extraChargeItems.value.pop();
    };

    const increaseQuantity = (index) =>
      extraChargeItems.value[index].quantity++;
    const decreaseQuantity = (index) =>
      extraChargeItems.value[index].quantity > 0 &&
      extraChargeItems.value[index].quantity--;

    const closeModal = () => {
      resetForm();
      updateModal(false);
    };

    const updateModal = (value) => emit("update:modal", value);

    const totalExtraChargePrice = computed(() => {
      return extraChargeItems.value.reduce((sum, ext) => {
        const selectedItem = ext.extracharges.find(
          (item) => item.uuid === ext.selectedExtraChargeUuid
        );
        return sum + (selectedItem ? selectedItem.price * ext.quantity : 0);
      }, 0);
    });

    const handleExtraChargeCategory = (category, index) => {
      extraChargeItems.value[index].selectedExtraChargeUuid = null;
      getListExtraCharge(category, index);
    };

    const handleExtraCharge = (uuid, index) => {
      extraChargeItems.value[index].selectedExtraChargeUuid = uuid;
    };

    const handleAction = () => {
      if (props.uuid) {
        storeExtraCharge();
      }
    };

    const storeExtraCharge = async () => {
      isLoading.value = true;
      const payload = {
        extra_charges: extraChargeItems.value.map((item) => ({
          uuid: item.selectedExtraChargeUuid,
          quantity: item.quantity,
          price: item.extracharges[0]?.price,
          is_late_added: isLateAdded.value,
        })),
      };
      try {
        const response = await reservationRepository.addExtraCharge(
          props.uuid,
          payload
        );
        modalResponse.value = {
          toast: true,
          text: response.data.message,
          success: true,
        };
        emit("addedExtraCharge");
        resetForm();
        updateModal(false);
        isLoading.value = false;
      } catch (error) {
        isLoading.value = false;
        modalResponse.value = {
          toast: true,
          text: error.response.data.message,
          success: false,
        };
      }
    };

    const resetForm = () => {
      extraChargeItems.value = [
        {
          selectedExtraChargeUuid: null,
          selectedExtraChargeCategory: null,
          extracharges: [],
          quantity: 0,
          price: 0,
        },
      ];
    };

    watch(
      () => props.modal,
      (value) => {
        if (value) {
          getListExtraChargeCategory();
        }
      }
    );

    watch(
      () => props.from,
      (value) => {
        console.log(value);

        if (value === "reservation" || value === "checkin")
          isLateAdded.value = false;
        if (value === "inhouse") isLateAdded.value = true;
      }
    );

    onMounted(() => {
      if (props.from === "reservation" || props.from === "checkin")
        isLateAdded.value = false;
      if (props.from === "inhouse") isLateAdded.value = true;
    });

    return {
      isLoading,
      isLateAdded,
      extraChargeItems,
      extraChargeCategories,
      modalResponse,
      storeExtraCharge,
      getListExtraChargeCategory,
      getListExtraCharge,
      addItemExtraCharge,
      deleteItemExtracharge,
      increaseQuantity,
      decreaseQuantity,
      closeModal,
      updateModal,
      totalExtraChargePrice,
      handleExtraChargeCategory,
      handleExtraCharge,
      handleAction,
      resetForm,
      formatIDR,
    };
  },
};
</script>

<style>
@media screen and (max-width: 576px) {
  .modal-title .title {
    font-size: 1rem;
  }
  .modal-title .date,
  .modal-title .info-status {
    font-size: 0.675rem;
  }
}
</style>
